module.exports = __webpack_public_path__ + "static/img/1.a17490f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bukanga-Lonzo/1.jpg
// module id = OnmR
// module chunks = 0